<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import PikuTradeComponent from "@/component/project/PikuTradeComponent.vue";

@Component({
  components: {PikuTradeComponent, NavBar}
})
export default class PikuTradeView extends Vue {

}
</script>

<template>
  <NavBar/>
  <div class="view-container">
    <PikuTradeComponent/>
  </div>
</template>

<style scoped>
.view-container {
  min-height: calc(100vh - var(--ln-nav-offset));
  padding: 3rem 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (max-width: 768px) {
  .view-container {
    padding: 1rem;
  }
}
</style>